import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const rankedComics = [...comics]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 10);

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="ranking-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">人气排行</span>
              <h2 id="ranking-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
                口碑<span className="italic font-normal text-accent-500">排行榜</span>
              </h2>
            </div>
            <Link to="/" className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              完整榜单 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="bg-background-50 rounded-2xl overflow-hidden">
            {rankedComics.map((comic, index) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className={`flex items-center gap-4 p-4 transition-colors hover:bg-background-100 cursor-pointer ${
                  index < rankedComics.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                  index < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {index + 1}
                </div>

                <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 line-clamp-1">{comic.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                </div>

                <div className="hidden sm:flex items-center gap-4 flex-shrink-0">
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                    comic.status === '连载中'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {comic.status}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.category}</span>
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  <span className="text-sm font-semibold text-foreground-900">{comic.rating}</span>
                </div>

                <div className="flex-shrink-0 text-foreground-300">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}